import {Component, OnDestroy, OnInit} from '@angular/core';
import {DiscountModel} from '../../../../models/DiscountModel';
import {LocalCustomerModel} from '../../../../models/LocalCustomerModel';
import {RegionModel} from '../../../../models/RegionModel';
import {Subscription} from 'rxjs';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {DiscountService} from '../service-discount/discount.service';
import {LoaderService} from '../../../general-services/service-loader/loader.service';
import {NumAnnoMeseService} from '../../../general-services/service-num-anno-mese/num-anno-mese.service';
import * as toastr from 'toastr';
import {MatDialog} from '@angular/material';
import {DialogSubmitDiscountComponent} from '../../../general-components/dialog-submit-discount/dialog-submit-discount.component';
import {ProviderModel} from '../../../../models/ProviderModel';
import {BaseGeneralComponent} from '../../../BaseGeneralComponent';

@Component({
  selector: 'app-edit-discount-massive',
  templateUrl: './edit-discount-massive.component.html',
  styleUrls: ['./edit-discount-massive.component.scss']
})
export class EditDiscountMassiveComponent extends BaseGeneralComponent implements OnInit, OnDestroy {

  showActions: boolean;
  anagrafInSettings: boolean;
  showAnnoMese: boolean;
  numAnnoFrom: any;
  submitted = false;

  discount: DiscountModel;
  discountTmp: DiscountModel;
  localCustomerSelect: LocalCustomerModel;
  regionSelect: RegionModel;
  providerSelect: ProviderModel;
  discountSelect: number;
  numAnnoSelect: number;
  selected: string;
  saveDiscount: Subscription;
  parameterSubscribe: Subscription;

  registerForm: FormGroup;
  discountJson: any;

  allYear: any;
  getPageSubscribe: Subscription;
  getFirstYearSubscribe: Subscription;

  constructor(private route: ActivatedRoute, private router: Router,
              private discountService: DiscountService,
              private formBuilder: FormBuilder,
              private loaderService: LoaderService,
              private dialog: MatDialog,
              private annoMeseService: NumAnnoMeseService) {
    super();

    this.showActions = false;
    this.anagrafInSettings = true;
    this.showAnnoMese = false;
    this.discount = new DiscountModel();
    this.discountTmp = new DiscountModel();
    this.localCustomerSelect = new LocalCustomerModel();
    this.regionSelect = new RegionModel();
    this.providerSelect = new ProviderModel();

    this.getAllYear();
    // this.getFirtsYear();
  }

  ngOnInit() {
    this.parameterSubscribe = this.route
      .queryParams
      .subscribe(params => {
        this.discountJson = params['row'];
        this.discountTmp = JSON.parse(this.discountJson) as DiscountModel;
        this.localCustomerSelect = this.discountTmp.localCustomer;
        this.regionSelect = this.discountTmp.region;
        this.providerSelect = this.discountTmp.provider;
        this.discountSelect = this.discountTmp.discount;
      });

    this.getAllYear();

    this.registerForm = this.formBuilder.group({
      localCustomerCod: [{value: '', disabled: false}, Validators.required],
      region: [{value: '', disabled: false}, Validators.required],
      provider: [{value: '', disabled: false}, Validators.required],
      discount: [{value: '', disabled: false}, Validators.required],
      annoFrom: [{value: '', disabled: false}, Validators.required],
      annoTo: [{value: '', disabled: false}, Validators.required]
    });

    this.registerForm.patchValue({
      localCustomerCod: this.localCustomerSelect.cod
    });

    this.registerForm.patchValue({
      region: this.regionSelect.cod
    });

    this.registerForm.patchValue({
      provider: this.providerSelect.cod
    });

    this.registerForm.patchValue({
      discount: this.discountSelect
    });
  }

  cancel(event: any) {
    event.preventDefault();
    this.router.navigate([this.LINKS.CONTRACTUAL_DATA], {queryParams: {selectedIndex: 1}});
  }

  save() {
    this.submitted = true;
    if (this.registerForm.valid) {
      event.preventDefault();
      this.loaderService.display(true);
      this.discount.id = this.discountTmp.id;
      this.discount.region = this.discountTmp.region;
      this.discount.localCustomer = this.discountTmp.localCustomer;
      this.discount.provider = this.discountTmp.provider;
      this.discount.discount = this.registerForm.value.discount;
      this.discount.numAnno = null;
      this.discount.numAnnoFrom = this.registerForm.value.annoFrom;
      this.discount.numAnnoTo = this.registerForm.value.annoTo;
      this.saveDiscount = this.discountService.updateMassive(this.discountService.baseUrl, this.discount)
        .subscribe(
          (result: any) => {
            if (result === -1) {
              toastr.options.timeout = 5000;
              toastr.warning('Duplicate item, cannot be created', 'Warning');
              this.loaderService.display(false);
            } else {
              this.loaderService.display(false);
              this.apriDialog(result);
              this.router.navigate([this.LINKS.CONTRACTUAL_DATA], {queryParams: {selectedIndex: 1}});
            }
          },
          error => {
            toastr.error('Discount element was not edited', 'Error');
            this.loaderService.display(false);
          });
    }
  }

  getFirtsYear() {
    this.loaderService.display(true);
    this.getFirstYearSubscribe = this.annoMeseService.getFirtsYear()
      .subscribe(
        (result: any) => {
          this.numAnnoFrom = result;
          this.loaderService.display(false);
        });
  }

  ngOnDestroy(): void {
    if (this.saveDiscount) {
      this.saveDiscount.unsubscribe();
    }
    if (this.parameterSubscribe) {
      this.parameterSubscribe.unsubscribe();
    }
  }

  getElementSelectedLC($event) {
    this.discount.localCustomer = $event.row;
    this.localCustomerSelect = $event.row;
    this.registerForm.patchValue({
      localCustomerCod: this.localCustomerSelect.cod
    });
  }

  getElementSelectedRegion($event) {
    this.discount.region = $event.row;
    this.regionSelect = $event.row;
    this.registerForm.patchValue({
      region: this.regionSelect.cod
    });
  }

  getElementSelectedProvider($event) {
    this.discount.provider = $event.row;
    this.providerSelect = $event.row;
    this.registerForm.patchValue({
      provider: this.providerSelect.cod
    });


  }

  handleNumAnnoMeseFrom(value) {
    this.discount.numAnnoFrom = value;
    this.registerForm.patchValue({
      annoFrom: value
    });
  }
  handleNumAnnoMeseTo(value) {
    this.discount.numAnnoTo = value;
    this.registerForm.patchValue({
      annoTo: value
    });
  }
  // convenience getter for easy access to form fields
  get f() { return this.registerForm.controls; }

  getAllYear() {
    this.getPageSubscribe = this.annoMeseService.getAllYear()
      .subscribe(
        (result: any) => {
          this.allYear = result;
        });
  }

  apriDialog(result: any) {
    const dialogRef = this.dialog.open(DialogSubmitDiscountComponent, {
      data: {result}
    });

    dialogRef.afterClosed().subscribe(result => {
      // console.log('The dialog was closed');
    });
  }

}


